import * as Icons from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, SectionHead } from "./Reveal";
import { DESIGN_FLOW, IMAGES } from "../data/site";

export const StructuralDesign = () => (
  <section
    id="structural-design"
    data-testid="structural-design-section"
    className="relative overflow-hidden bg-[#0A0A0A] px-6 py-24 md:px-12 md:py-32"
  >
    <div className="absolute inset-0 blueprint-grid opacity-40" aria-hidden />
    <div className="relative mx-auto max-w-7xl">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-8">
        <div className="md:col-span-7">
          <SectionHead
            id="structural-design"
            overline="Chapter 03 — Engineering First"
            title="Structural Design & Engineering"
            desc="We provide structural design solutions focused on safety, functionality, durability and efficient use of materials. Our structural solutions can be tailored for residential, commercial, industrial, roofing and prefabricated construction requirements."
          />
        </div>
        <Reveal delay={0.15} className="md:col-span-5">
          <div className="group relative overflow-hidden border border-white/10">
            <img
              src={IMAGES.structuralDesign}
              alt="Structural design and engineering work"
              className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <span className="absolute bottom-4 left-4 text-[10px] uppercase tracking-[0.3em] text-white/70">
              Design · Engineering · Execution
            </span>
          </div>
        </Reveal>
      </div>

      <div className="mt-20" data-testid="design-flow">
        <div className="grid grid-cols-2 gap-y-12 sm:grid-cols-3 lg:grid-cols-6">
          {DESIGN_FLOW.map((step, i) => {
            const Icon = Icons[step.icon];
            return (
              <div key={step.label} className="relative flex flex-col items-center text-center">
                {i < DESIGN_FLOW.length - 1 && (
                  <motion.span
                    aria-hidden
                    initial={{ scaleX: 0 }}
                    whileInView={{ scaleX: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: 0.2 + i * 0.12 }}
                    className="absolute left-[calc(50%+40px)] top-8 hidden h-px w-[calc(100%-80px)] origin-left bg-gradient-to-r from-[#0055FF] to-white/15 lg:block"
                  />
                )}
                <motion.div
                  initial={{ opacity: 0, scale: 0.6 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
                  className="flex h-16 w-16 items-center justify-center border border-white/15 bg-[#050505] transition-colors hover:border-[#0055FF]"
                >
                  <Icon size={24} strokeWidth={1.5} className="text-[#3377FF]" />
                </motion.div>
                <motion.p
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.1 + i * 0.12 }}
                  className="mt-4 text-xs font-semibold uppercase tracking-[0.2em] text-white/80"
                >
                  {step.label}
                </motion.p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
